'use client'

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuthTab } from '@/hooks/useAuthModal'
import { useAuth } from '@/stores/auth'

/*
 * 舊站的登入與註冊是**獨立的頁**（/Index/login、/Manger/register、/Member/join），
 * React 版是一顆視窗。客人的書籤、站內信、簡訊裡都是那些網址，直接 404 不行。
 *
 * 這一支不畫任何東西:進來就把登入視窗打開、切到對的分頁，然後把網址換成首頁。
 * `rtn` 是舊站帶「登入後回哪一頁」的參數，照收。
 */
export default function AuthEntry() {
  const navigate = useNavigate()
  const openLogin = useAuth((s) => s.openLogin)
  const setTab = useAuthTab((s) => s.setTab)

  useEffect(() => {
    const path = window.location.pathname
    const rtn = new URLSearchParams(window.location.search).get('rtn')

    // 註冊類的網址切到註冊分頁，其餘是登入
    setTab(/register|join/i.test(path) ? 'register' : 'login')

    // rtn 只收本站的相對路徑 —— 收外站網址等於開一個轉址漏洞
    let intended = null
    if (rtn) {
      try {
        const u = new URL(rtn, window.location.origin)
        if (u.origin === window.location.origin) intended = u.pathname + u.search
      } catch {
        // 壞掉的 rtn 就當作沒帶
      }
    }

    openLogin(intended)
    navigate('/', { replace: true })
  }, [openLogin, setTab, navigate])

  return null
}
